// com53 gallery
const images = document.querySelectorAll('.gallery-anim-1');

if (images) {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('show');
                observer.unobserve(entry.target);
            }
        });
    }, {threshold: 0.8}); // kdy to spustit (30 % viditelnosti)

    images.forEach(img => observer.observe(img));
}


// com48 hero gallery - foregroudn
const heroImages = document.querySelectorAll('.hero-img');

if (heroImages) {
    const observer2 = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('show');
                observer2.unobserve(entry.target);
            }
        });
    }, {threshold: 0.2}); // kdy to spustit (30 % viditelnosti)

    heroImages.forEach(img => observer2.observe(img));
}
// com48 hero gallery - background
const heroBgImages = document.querySelectorAll('.icon-bg-box');

if (heroBgImages) {
    const observer3 = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('show');
                observer3.unobserve(entry.target);
            }
        });
    }, {threshold: 0.2}); // kdy to spustit (30 % viditelnosti)

    heroBgImages.forEach(img => observer3.observe(img));
}
// com48 hero gallery - text
const heroText = document.querySelectorAll('.icon-box-text');

if (heroText) {
    const observer4 = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('show');
                observer4.unobserve(entry.target);
            }
        });
    }, {threshold: 0.2}); // kdy to spustit (30 % viditelnosti)

    heroText.forEach(img => observer4.observe(img));
}
